import { NegotiationFieldMeta } from 'api'

export const PreAssignmentNames = {
  ALL_IN_PRICE_IS_MODIFIED: 'negotiationFields.ALL_IN_PRICE.negotiableFieldRequired.modified',
  ALL_IN_PRICE_MODIFIED: 'negotiationFields.ALL_IN_PRICE.negotiableFieldRequired.modifiedValue',
  ALL_IN_PRICE_NEGOTIATED: 'negotiationFields.ALL_IN_PRICE.negotiableFieldRequired.negotiated',
  ALL_IN_PRICE_VALIDATION: 'allInPrice',
  ACCRUED_INTEREST_IS_MODIFIED: 'negotiationFields.ACCRUED_INTEREST.negotiableFieldRequired.modified',
  ACCRUED_INTEREST_MODIFIED: 'negotiationFields.ACCRUED_INTEREST.negotiableFieldRequired.modifiedValue',
  ACCRUED_INTEREST_NEGOTIATED: 'negotiationFields.ACCRUED_INTEREST.negotiableFieldRequired.negotiated',
  ACCRUED_INTEREST_VALIDATION: 'accruedInterest',
  END_CONSIDERATION_IS_MODIFIED: 'negotiationFields.END_CONSIDERATION.negotiableFieldRequired.modified',
  END_CONSIDERATION_MODIFIED: 'negotiationFields.END_CONSIDERATION.negotiableFieldRequired.modifiedValue',
  END_CONSIDERATION_NEGOTIATED: 'negotiationFields.END_CONSIDERATION.negotiableFieldRequired.negotiated',
  END_CONSIDERATION_VALIDATION: 'endConsideration',
  FUND_ID_IS_MODIFIED: 'negotiationFields.FUND_ID.negotiableFieldRequired.modified',
  FUND_ID_MODIFIED: 'negotiationFields.FUND_ID.negotiableFieldRequired.modifiedValue',
  FUND_ID_NEGOTIATED: 'negotiationFields.FUND_ID.negotiableFieldRequired.negotiated',
  FUND_ID_VALIDATION: 'fundId',
  HAIRCUT_IS_MODIFIED: 'negotiationFields.HAIRCUT.negotiableFieldRequired.modified',
  HAIRCUT_MODIFIED: 'negotiationFields.HAIRCUT.negotiableFieldRequired.modifiedValue',
  HAIRCUT_NEGOTIATED: 'negotiationFields.HAIRCUT.negotiableFieldRequired.negotiated',
  HAIRCUT_VALIDATION: 'haircut',
  HAIRCUT_TYPE_IS_MODIFIED: 'negotiationFields.HAIRCUT_TYPE.negotiableFieldRequired.modified',
  HAIRCUT_TYPE_MODIFIED: 'negotiationFields.HAIRCUT_TYPE.negotiableFieldRequired.modifiedValue',
  HAIRCUT_TYPE_NEGOTIATED: 'negotiationFields.HAIRCUT_TYPE.negotiableFieldRequired.negotiated',
  HAIRCUT_TYPE_VALIDATION: 'haircutType',
  INITIATOR_BOOK_IS_MODIFIED: 'negotiationFields.INITIATOR_BOOK.negotiableFieldRequired.modified',
  INITIATOR_BOOK_MODIFIED: 'negotiationFields.INITIATOR_BOOK.negotiableFieldRequired.modifiedValue',
  INITIATOR_BOOK_NEGOTIATED: 'negotiationFields.INITIATOR_BOOK.negotiableFieldRequired.negotiated',
  INITIATOR_BOOK_VALIDATION: 'initiatorBook',
  INITIATOR_STRATEGY_IS_MODIFIED: 'negotiationFields.INITIATOR_STRATEGY.negotiableFieldRequired.modified',
  INITIATOR_STRATEGY_MODIFIED: 'negotiationFields.INITIATOR_STRATEGY.negotiableFieldRequired.modifiedValue',
  INITIATOR_STRATEGY_NEGOTIATED: 'negotiationFields.INITIATOR_STRATEGY.negotiableFieldRequired.negotiated',
  INITIATOR_STRATEGY_VALIDATION: 'initiatorStrategy',
  NOTIONAL_IS_MODIFIED: 'negotiationFields.NOTIONAL.negotiableFieldRequired.modified',
  NOTIONAL_MODIFIED: 'negotiationFields.NOTIONAL.negotiableFieldRequired.modifiedValue',
  NOTIONAL_NEGOTIATED: 'negotiationFields.NOTIONAL.negotiableFieldRequired.negotiated',
  NOTIONAL_VALIDATION: 'notional',
  RATE_IS_MODIFIED: 'negotiationFields.FUND_ID.negotiableFieldRequired.modified',
  RATE_MODIFIED: 'negotiationFields.FUND_ID.negotiableFieldRequired.modifiedValue',
  RATE_NEGOTIATED: 'negotiationFields.FUND_ID.negotiableFieldRequired.negotiated',
  RATE_VALIDATION: 'rate',
  REPO_INTEREST_IS_MODIFIED: 'negotiationFields.REPO_INTEREST.negotiableFieldRequired.modified',
  REPO_INTEREST_MODIFIED: 'negotiationFields.REPO_INTEREST.negotiableFieldRequired.modifiedValue',
  REPO_INTEREST_NEGOTIATED: 'negotiationFields.REPO_INTEREST.negotiableFieldRequired.negotiated',
  REPO_INTEREST_VALIDATION: 'repoInterest',
  START_CONSIDERATION_IS_MODIFIED: 'negotiationFields.START_CONSIDERATION.negotiableFieldRequired.modified',
  START_CONSIDERATION_MODIFIED: 'negotiationFields.START_CONSIDERATION.negotiableFieldRequired.modifiedValue',
  START_CONSIDERATION_NEGOTIATED: 'negotiationFields.START_CONSIDERATION.negotiableFieldRequired.negotiated',
  START_CONSIDERATION_VALIDATION: 'startConsideration',
  START_CONSIDERATION_OVERRIDE_IS_MODIFIED: 'negotiationFields.START_CONSIDERATION_OVERRIDE.negotiableFieldRequired.modified',
  START_CONSIDERATION_OVERRIDE_MODIFIED: 'negotiationFields.START_CONSIDERATION_OVERRIDE.negotiableFieldRequired.modifiedValue',
  START_CONSIDERATION_OVERRIDE_NEGOTIATED: 'negotiationFields.START_CONSIDERATION_OVERRIDE.negotiableFieldRequired.negotiated',
  START_CONSIDERATION_OVERRIDE_VALIDATION: 'startConsiderationOverride'
} as const

export type PreAssignmentName = typeof PreAssignmentNames[keyof typeof PreAssignmentNames]

export function preAssignmentNamesToNegotiationFieldMeta(name: PreAssignmentName) {
  const preAssignmentNamesToNegotiationFieldMetaMap = {
    [PreAssignmentNames.FUND_ID_MODIFIED]: NegotiationFieldMeta.FUND_ID,
    [PreAssignmentNames.FUND_ID_NEGOTIATED]: NegotiationFieldMeta.FUND_ID,
    [PreAssignmentNames.INITIATOR_BOOK_MODIFIED]: NegotiationFieldMeta.INITIATOR_BOOK,
    [PreAssignmentNames.INITIATOR_BOOK_NEGOTIATED]: NegotiationFieldMeta.INITIATOR_BOOK,
    [PreAssignmentNames.INITIATOR_STRATEGY_MODIFIED]: NegotiationFieldMeta.INITIATOR_STRATEGY,
    [PreAssignmentNames.INITIATOR_STRATEGY_NEGOTIATED]: NegotiationFieldMeta.INITIATOR_STRATEGY,
    [PreAssignmentNames.NOTIONAL_MODIFIED]: NegotiationFieldMeta.NOTIONAL,
    [PreAssignmentNames.NOTIONAL_NEGOTIATED]: NegotiationFieldMeta.NOTIONAL,
    [PreAssignmentNames.START_CONSIDERATION_MODIFIED]: NegotiationFieldMeta.START_CONSIDERATION,
    [PreAssignmentNames.START_CONSIDERATION_NEGOTIATED]: NegotiationFieldMeta.START_CONSIDERATION,
    [PreAssignmentNames.START_CONSIDERATION_OVERRIDE_MODIFIED]: NegotiationFieldMeta.START_CONSIDERATION_OVERRIDE,
    [PreAssignmentNames.START_CONSIDERATION_OVERRIDE_NEGOTIATED]: NegotiationFieldMeta.START_CONSIDERATION_OVERRIDE
  } as const

  if (name in preAssignmentNamesToNegotiationFieldMetaMap) {
    return preAssignmentNamesToNegotiationFieldMetaMap[name as keyof typeof preAssignmentNamesToNegotiationFieldMetaMap]
  }

  return null
}
